import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import { from, of } from 'rxjs';
import { concatMap, delay, catchError } from 'rxjs/operators';

@Component({
  selector: 'app-send-reminder-letter-book',
  templateUrl: './send-reminder-letter-book.component.html',
  styleUrl: './send-reminder-letter-book.component.scss'
})
export class SendReminderLetterBookComponent {

  currentDate: Date = new Date();

  reportType: any;

   letterBodyText = {
    template_name: 'send-reminder2',
    subject_line: '',
    greeting: '',
    paragraph1: '',
    paragraph2: '',
    paragraph3: '',
    details_heading: '',
    closing_text: ''
  };
  

  letters: any[] = [];   // ⭐ GROUPED DATA (IMPORTANT)

  isEditMode: boolean = false;
  isSaving: boolean = false;

  // letterBodyText: any;
  defaultLetterText: any;
  show: boolean;
  sendingAllWhatsApp = false;

  constructor(
    private dialogRef: MatDialogRef<SendReminderLetterBookComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {

    this.reportType = this.data?.reportType;

    this.loadLetterTemplate();

    const req = {
      rep_name: this.data?.repName,
      start_date: this.data?.startDate,
      end_date: this.data?.endDate,
      booksellername: this.data?.booksellername
    };

    this.service.getpendingreceipt1(req).subscribe((res: any) => {

      const records = (res?.data || []).map((item: any) => ({
        invoice_no: item.invoice_no,
        invoice_date: item.invoice_date,
        invoice_total: Number(item.invoice_total) || 0,
        unpaid_amt: Number(item.unpaid_amt) || 0,
        book_seller_name: item.book_seller_name,
        district: item.district,
        mobile: item.mobile_no
      }));

      

      // ⭐ GROUP BY BOOKSELLER
      const grouped: any = {};

      records.forEach((r: any) => {

        if (!grouped[r.book_seller_name]) {
    grouped[r.book_seller_name] = {
        booksellername: r.book_seller_name,
        district: r.district,
        mobile: r.mobile,
        invoices: [],
        totalInvoice: 0,
        totalBalance: 0
    };
}

        grouped[r.book_seller_name].invoices.push(r);
        grouped[r.book_seller_name].totalInvoice += r.invoice_total;
        grouped[r.book_seller_name].totalBalance += r.unpaid_amt;
      });

      this.letters = Object.values(grouped);

      this.cdr.detectChanges();
    });
  }

  /* ================= TEMPLATE ================= */

  loadLetterTemplate(): void {
    this.service.getLetterTemplate('send-reminder1').subscribe((res: any) => {

      if (res?.success && res?.data) {
        this.letterBodyText = res.data;
      } else {
        this.letterBodyText = this.getDefaultTemplate();
      }

      this.cdr.detectChanges();
    });
  }
  getDefaultTemplate(): any {
    throw new Error('Method not implemented.');
  }
  printPage(): void {
    const printSection = document.getElementById('print-section');
    if (!printSection) {
      console.error('Print section not found!');
      return;
    }

    printSection.querySelectorAll('textarea').forEach((ta) => {
      ta.setAttribute('data-live-value', (ta as HTMLTextAreaElement).value);
    });
    printSection.querySelectorAll('input[type="text"]').forEach((inp) => {
      inp.setAttribute('data-live-value', (inp as HTMLInputElement).value);
    });

    const clone = printSection.cloneNode(true) as HTMLElement;
    const origin = window.location.origin;

    clone.querySelectorAll('img').forEach((imgEl) => {
      const el = imgEl as HTMLImageElement;
      if (el.src) {
        el.setAttribute('src', el.src);
      }
    });

    clone.querySelectorAll('textarea[data-live-value]').forEach((ta) => {
      const value = ta.getAttribute('data-live-value') || '';
      const p = document.createElement('p');
      p.textContent = value;
      p.style.whiteSpace = 'pre-wrap';
      ta.replaceWith(p);
    });
    clone.querySelectorAll('input[type="text"][data-live-value]').forEach((inp) => {
      const value = inp.getAttribute('data-live-value') || '';
      const span = document.createElement('span');
      span.textContent = value;
      inp.replaceWith(span);
    });

    const printContent = clone.outerHTML;

    const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');
    if (!printWindow) {
      console.error('Failed to open print window. Check popup blocker.');
      alert('Popup blocked. Please allow popups for this site to print.');
      return;
    }

    printWindow.document.open();
    printWindow.document.write(`
    <html>
      <head>
        <meta charset="UTF-8">
        <base href="${origin}/">
        <title>स्मरणपत्र</title>
        <style>
          * { margin: 0; padding: 0; box-sizing: border-box; }

          body {
            font-family: 'Noto Sans Devanagari', Arial, sans-serif;
            color: #000 !important;
            background: white;
            font-size: 14px;
          }

          @page { size: A4 portrait; margin: 8mm 10mm; }

          @media print {
            body { width: 210mm; margin: 0; padding: 0; }
            .no-print, button, .edit-controls { display: none !important; }
          }

          .page-break { page-break-after: always; break-after: page; height: 0; }

          .reminder-container {
            max-width: 210mm;
            margin: 0 auto 10px auto;
            padding: 10px;
            background: #fff;
            font-family: 'Noto Sans Devanagari', Arial, sans-serif;
            color: #000 !important;
            border: 2px solid #000;
            page-break-inside: avoid;
            break-inside: avoid;
            display: block;
          }

          .header-section { padding-bottom: 4px; color: #000 !important; }
          .header-content { color: #000 !important; }

          .header-top {
            display: table;
            width: 100%;
            table-layout: fixed;
            border-spacing: 0;
            padding-bottom: 4px;
          }
          .organization-info {
            display: table-cell;
            vertical-align: top;
            text-align: right;
            padding-top: 8px;
            line-height: 1.25;
            padding-right: 25px;
          }
          .organization-name {
            font-size: 19px; font-weight: bold; margin: 0 0 2px 0;
            color: #000; text-align: right;
          }
          .registration-number {
            font-size: 12px; color: #000 !important; text-align: right;
            display: block; margin-bottom: -6px;
          }
          .office-label, .contact-label { font-weight: bold; color: #000 !important; }
          .header-logo { display: table-cell; vertical-align: middle; width: 90px; text-align: center; }
          .header-logo img { max-width: 85px; margin-top: 4px; margin-bottom: 4px; }
          .header-divider { margin: 1px 0; border: none; border-top: 1px solid #333; }
          .office-details-single { font-size: 12px; line-height: 1.25; color: #000 !important; text-align: left; }

          h2 { font-size: 16px; margin: 4px 0 !important; }

          .subject-line { text-align: center; font-weight: bold; font-size: 14px; margin: 4px 0 !important; color: #000 !important; }
          .greeting { text-align: left; font-weight: normal; font-size: 14px; margin-bottom: 4px !important; color: #000 !important; }
          .letter-body { font-size: 12px; line-height: 1.25; text-align: justify; color: #000 !important; }
          .letter-body p { margin: 3px 0 !important; text-indent: 30px; color: #000 !important; white-space: pre-wrap; }
          .letter-body > div { margin-bottom: 3px !important; }
          .details-heading { font-weight: bold; font-size: 13px; margin: 4px 0 3px 0 !important; color: #000 !important; text-indent: 0 !important; }

          hr { margin: 3px 0 !important; }

          table { width: 100%; border-collapse: collapse; font-size: 12px; }
          table th, table td { color: #000 !important; padding: 5px 6px !important; height: auto !important; font-size: 12px !important; }
          table thead { display: table-header-group; }
          table tbody tr { page-break-inside: avoid; break-inside: avoid; }

          /* ⭐ WIDTH FIX: previously width:100% !important stretched the
             bank box across the entire page. Narrowed to 62% (matching the
             original col-7 intent of ~58%) so it reads as a compact box,
             not a full-width bar. Adjust the % below if you want it
             narrower/wider. */
          .col-7 {
            display: table !important;
            width: 62% !important;
            table-layout: fixed !important;
            border-spacing: 0 !important;
            padding: 8px 0 0 0 !important;
            page-break-inside: avoid;
            break-inside: avoid;
          }
          .col-7 > div {
            display: table-row !important;
            border: none !important;
            padding: 0 !important;
          }
          .col-7 > div > div {
            display: table-cell !important;
            vertical-align: top !important;
            border: 2px solid #000 !important;
            padding: 8px !important;
            margin: 0 !important;
            flex: none !important;
          }
          .col-7 > div > div:first-child {
            border-right: none !important;
          }
          .col-7 > div > div:last-child {
            border-left: none !important;
            text-align: center !important;
            width: 95px !important;
          }
          .col-7 img {
            width: 65px !important;
            height: 65px !important;
            border: none !important;
            object-fit: contain !important;
            display: inline-block !important;
          }
          .col-7 div[style*="font-size: 14px"] { font-size: 12px !important; margin-bottom: 4px !important; }
          .col-7 div[style*="font-size: 12px"] { font-size: 11px !important; line-height: 1.35 !important; }

          div[style*="text-align:right"][style*="font-weight:bold"] {
            page-break-inside: avoid;
            break-inside: avoid;
            margin-top: 12px !important;
            font-size: 13px !important;
          }

          .no-print, button, .edit-controls { display: none !important; }
        </style>
      </head>
      <body>
        ${printContent}
      </body>
    </html>
  `);
    printWindow.document.close();

    let closed = false;
    const safeClose = () => {
      if (closed) return;
      closed = true;
      printWindow.close();
    };
    printWindow.addEventListener('afterprint', safeClose);

    const triggerPrint = () => {
      printWindow.focus();
      printWindow.print();
      setTimeout(safeClose, 2000);
    };

    const images = Array.from(printWindow.document.images);
    if (images.length === 0) {
      triggerPrint();
      return;
    }

    let loadedCount = 0;
    const total = images.length;
    const onAnyImageSettled = () => {
      loadedCount++;
      if (loadedCount >= total) {
        triggerPrint();
      }
    };

    images.forEach((img) => {
      if (img.complete) {
        onAnyImageSettled();
      } else {
        img.addEventListener('load', onAnyImageSettled, { once: true });
        img.addEventListener('error', onAnyImageSettled, { once: true });
      }
    });

    setTimeout(() => {
      if (loadedCount < total) {
        triggerPrint();
      }
    }, 3000);
  }

  toggleEditMode(): void {
    this.isEditMode = !this.isEditMode;
    if (!this.isEditMode) {
      this.loadLetterTemplate();
    }
  }

  saveLetterTemplate(): void {
    this.isSaving = true;
    this.service.saveLetterTemplate(this.letterBodyText).subscribe(
      (res: any) => {
        this.isSaving = false;
        if (res?.success) {
          alert('Template saved successfully');
          this.isEditMode = false;
        } else {
          alert('Error saving template');
        }
      },
      () => {
        this.isSaving = false;
        alert('Error saving template');
      }
    );
  }

  resetToDefault(): void {
    if (confirm('Reset to default template?')) {
      this.letterBodyText = { ...this.defaultLetterText };
      this.saveLetterTemplate();
    }
  }


  //   sendWhatsAppReminder(letter: any): void {

  //   if (!letter.mobile) {
  //     alert('Mobile number not found for ' + letter.booksellername);
  //     return;
  //   }

  //   const payload = {
  //     mobile: letter.mobile,
  //     campaignName: 'YOUR_AISENSY_CAMPAIGN_NAME',

  //     booksellername: letter.booksellername,   // {{1}}
  //     district: letter.district,               // {{2}}
  //     date: this.formatDate(this.currentDate), // {{3}}
  //     total_amount: letter.totalBalance        // {{4}}
  //   };

  //   this.service.sendBookReminderWhatsapp(payload).subscribe(
  //     (res: any) => {
  //       alert('WhatsApp message sent successfully');
  //     },
  //     (err: any) => {
  //       console.error('WhatsApp send failed:', err);
  //       alert('WhatsApp message failed');
  //     }
  //   );
  // }


  // sendWhatsAppReminder(letter: any) {

  //   if (!letter.mobile) {
  //     alert('Mobile number not available.');
  //     return;
  //   }

  //   const payload = {
  //     mobile: letter.mobile,
  //     campaignName: 'book_reminder', // Your AISensy Campaign Name
  //     templateParams: [
  //       letter.booksellername,                    // {{1}}
  //       letter.district,                          // {{2}}
  //       this.formatDate(this.currentDate),        // {{3}}
  //       Number(letter.totalBalance).toFixed(2)    // {{4}}
  //     ]
  //   };

  //   this.service.sendBookReminderWhatsapp(payload).subscribe({
  //     next: (res: any) => {
  //       console.log(res);
  //       alert('WhatsApp message sent successfully.');
  //     },
  //     error: (err: any) => {
  //       console.error(err);
  //       alert('Failed to send WhatsApp message.');
  //     }
  //   });

  // }


//   isWhatsAppSent = false;
//   sendWhatsAppReminder(letter: any): void {

//   if (!letter) {
//     alert('Letter data not found');
//     return;
//   }

//   if (!letter.mobile) {
//     alert('Mobile number not found for ' + letter.booksellername);
//     return;
//   }

//   const payload = {
//     mobile: letter.mobile,
//     campaignName: 'outstanding',
//     templateParams: [
//       letter.booksellername,
//       letter.district || '',
//       this.formatDate(this.currentDate),
//       Number(letter.totalBalance).toFixed(2)
//     ]
//   };

//   this.service.sendWhatsAppReceipt(payload).subscribe({
//     next: () => alert('WhatsApp sent successfully'),
//     error: (err: any) => {
//       console.error('WhatsApp failed:', err);
//       alert('WhatsApp failed');
//        this.isWhatsAppSent = true;
//     }
//   });
// }

isWhatsAppSent = false;

// sendWhatsAppReminder(letter: any): void {

//   if (!letter) {
//     alert('Letter data not found');
//     return;
//   }

//   if (!letter.mobile) {
//     alert('Mobile number not found for ' + letter.booksellername);
//     return;
//   }

//   const payload = {
//     mobile: letter.mobile,
//     campaignName: 'outstanding',
//     templateParams: [
//       letter.booksellername,
//       letter.district || '',
//       this.formatDate(this.currentDate),
//       Number(letter.totalBalance).toFixed(2)
//     ]
//   };

//   this.service.sendWhatsAppReceipt(payload).subscribe({
//     next: () => {
//       alert('WhatsApp sent successfully');
//       this.isWhatsAppSent = true;   // Hide button after success
//     },
//     error: (err: any) => {
//       console.error('WhatsApp failed:', err);
//       alert('WhatsApp failed');
//     }
//   });
// }

  formatDate(date: Date): string {
    const d = String(date.getDate()).padStart(2, '0');
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const y = date.getFullYear();
    return `${d}/${m}/${y}`;
  }


  private buildWhatsAppReminderPayload(letter: any): { mobile: string; campaignName: string; templateParams: string[] } | null {

  if (!letter?.mobile) {
    return null;
  }

  return {
    mobile: letter.mobile,
    campaignName: 'outstanding',
    templateParams: [
      letter.booksellername,
      letter.district || '',
      this.formatDate(this.currentDate),
      Number(letter.totalBalance).toFixed(2)
    ]
  };
}

// ================= SEND SINGLE REMINDER (now per-letter tracked) =================
sendWhatsAppReminder(letter: any): void {

  if (!letter) {
    alert('Letter data not found');
    return;
  }

  const payload = this.buildWhatsAppReminderPayload(letter);

  if (!payload) {
    alert('Mobile number not found for ' + letter.booksellername);
    return;
  }

  letter.isSendingWhatsApp = true;

  this.service.sendWhatsAppReceipt(payload).subscribe({
    next: () => {
      letter.isSendingWhatsApp = false;
      alert('WhatsApp sent successfully');
      letter.isWhatsAppSent = true;
    },
    error: (err: any) => {
      letter.isSendingWhatsApp = false;
      console.error('WhatsApp failed:', err);
      alert('WhatsApp failed');
    }
  });
}

// ================= SEND ALL REMINDERS (bulk, one-shot) =================
sendAllWhatsAppReminders(): void {

  if (!this.letters.length) {
    alert('पाठवण्यासाठी कोणतेही बुक सेलर उपलब्ध नाहीत.');
    return;
  }

  if (!confirm(`सर्व ${this.letters.length} बुक सेलर्सना स्मरणपत्र WhatsApp पाठवायचे आहे का?`)) return;

  const skipped: string[] = [];
  const failed: string[] = [];
  const sent: string[] = [];

  const jobs = this.letters
    .filter(l => !l.isWhatsAppSent) // don't re-send to ones already marked sent
    .map(letter => ({ letter, payload: this.buildWhatsAppReminderPayload(letter) }))
    .filter(job => {
      if (!job.payload) {
        skipped.push(job.letter.booksellername);
        return false;
      }
      return true;
    });

  if (!jobs.length) {
    alert('कोणत्याही बुक सेलरसाठी वैध मोबाईल नंबर उपलब्ध नाही.');
    return;
  }

  this.sendingAllWhatsApp = true;
  jobs.forEach(job => job.letter.isSendingWhatsApp = true);

  from(jobs).pipe(
    concatMap(job =>
      this.service.sendWhatsAppReceipt(job.payload!).pipe(
        delay(400), // gap between sends to avoid rate-limiting
        catchError(err => {
          console.error(`WhatsApp failed for ${job.letter.booksellername}:`, err);
          failed.push(job.letter.booksellername);
          return of(null);
        }),
        concatMap(res => {
          job.letter.isSendingWhatsApp = false;
          if (res !== null) {
            job.letter.isWhatsAppSent = true;
            sent.push(job.letter.booksellername);
          }
          return of(res);
        })
      )
    )
  ).subscribe({
    complete: () => {
      this.sendingAllWhatsApp = false;
      this.cdr.detectChanges();

      let msg = `✅ पाठवले: ${sent.length}`;
      if (failed.length) msg += `\n❌ अयशस्वी: ${failed.length} (${failed.join(', ')})`;
      if (skipped.length) msg += `\n⚠️ मोबाईल नंबर नाही: ${skipped.length} (${skipped.join(', ')})`;

      alert(msg);
    }
  });
}
}